import { render, staticRenderFns } from "./MobileNumber.vue?vue&type=template&id=2667b0c6&scoped=true&lang=pug&"
import script from "./MobileNumber.vue?vue&type=script&lang=js&"
export * from "./MobileNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2667b0c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})
